import React, { Component } from 'react'
import Stopwatch from '../Stopwatch'

class FormContainer extends Component {
  constructor (props) {
    super(props)

    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleFormReject = this.handleFormReject.bind(this)
  }

  handleFormSubmit (e) {
    e.preventDefault()
    this.props.onFormSubmit(e)
  }

  handleFormReject (e) {
    e.preventDefault()
    this.props.onFormReject(e)
  }

  render () {

    const { children, rejectBtnDisabled, rejectText, approveBtnDisabled, submitText, surveyTestURL } = this.props

    return (
      <div>
        {children}
        <div className="form-footer">
          <Stopwatch link={surveyTestURL} />
          <div className="form-buttons">
            <button className="axiom-button-button-negative axiom-button-icon-left"
              onClick={this.handleFormReject}
              disabled={rejectBtnDisabled}
            >
              <i className="axiom-icon-icon icon-slash"/>
              {rejectText}
            </button>
            <button className="axiom-button-button-positive axiom-button-icon-left"
              onClick={this.handleFormSubmit}
              disabled={approveBtnDisabled}
            >
              <i className="axiom-icon-icon icon-check-circle"/>
              {submitText}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default FormContainer
